<template>
  <div class="lp-container">
    <form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-4 text-center">
          <label class="lp-div lp-label" for="username">{{ $store.state.localization.data?.loginPage.loginLabel }}:</label>
        </div>
        <div class="col-8">
          <input class="lp-div lp-input" type="text" v-model="username" name="username" />
        </div>
      </div>
      <div class="row">
        <div class="col-4 text-center">
          <label class="lp-div lp-label" for="password">{{ $store.state.localization.data?.loginPage.passwordLabel }}:</label>
        </div>
        <div class="col-4">
          <input class="lp-div lp-input" type="password" v-model="password" name="password" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button class="lp-button" @click="clicked = 'login'">{{ $store.state.localization.data?.loginPage.loginButton }}</button>
        </div>
      </div>
      <div class="row" v-if="eusignEnabled">
        <div class="col-4 text-center">
          <label class="lp-div lp-label" for="signature">{{ $store.state.localization.data?.loginPage.signature }}:</label>
        </div>
        <div class="col-8">
          <input class="lp-div" type="checkbox" name="checkSignature" v-model="checkSignature"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <div class="lp-alert" v-show="isValidationError || $store.state.authentication.failedLogin">{{ validationError }}</div>
        </div>
      </div>
      <EuSignModal
        v-bind:signature="signature"
        ref="eusign-modal"
      ></EuSignModal>
      <ConfirmCodeModal
      ></ConfirmCodeModal>
    </form>
  </div>
</template>

<script>

/* global EndUser */

import apiService from '../../../services/api-service';
import { config } from '../../../config';

import EuSignModal from "../../EuSign/EuSignModal.vue";
import ConfirmCodeModal from "../../Emails/ConfirmCode/ConfirmCodeModal.vue";

export default {
  components: {
    EuSignModal,
    ConfirmCodeModal
  },
  data() {
    return {
      username: "",
      password: "",
      signature: null,
      checkSignature: false,
      isValidationError: false,
      validationError: "",
    };
  },
  computed: {
    eusignEnabled() {
      return config.eusign.enabled;
    }
  },
  async mounted() {
    if (config.eusign.enabled) {
      await apiService.loadScript("/eusign.js");
    }
  },
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    const impersonateUser = urlParams.get("impersonateUser");

    if (impersonateUser) {
      this.$store.dispatch("authentication/logout", {
        impersonateUser: true
      });

      this.$store.dispatch("authentication/impersonateUser", {
        impersonateUser: impersonateUser
      });
    } else {
      this.$store.dispatch("authentication/logout", {
        impersonateUser: false
      });
    }

    this.$store.dispatch("localization/initLocale");
  },
  methods: {
    async onSubmit() {
      if (this.clicked == "login") {
        if (!this.username || this.username.trim().length === 0) {
          this.validationError = this.$store.state.localization.data?.loginPage.loginError;
          this.isValidationError = true;
          return;
        }
  
        if (!this.password || this.password.trim().length === 0) {
          this.validationError = this.$store.state.localization.data?.loginPage.passwordError;
          this.isValidationError = true;
          return;
        }
  
        this.isValidationError = false;
        this.validationError = this.$store.state.localization.data?.loginPage.invalidLoginOrPasswordError;
  
        if (config.eusign.enabled && this.checkSignature) {
          let authTokenHash = await apiService.getEuSignSignature(this.username);

          this.signature = authTokenHash;

          // eslint-disable-next-line no-unused-vars
          authTokenHash = [
            new EndUser.NamedData('Токен доступу', authTokenHash )
          ];

          this.$refs["eusign-modal"].open();
          const signedHash = await this.$refs["eusign-modal"].getSignature();
          this.$refs["eusign-modal"].close();

          this.$store.dispatch("authentication/login", {
            username: this.username,
            password: this.password,
            signature: signedHash
          });
          
        } else {
          this.$store.dispatch("authentication/login", {
            username: this.username,
            password: this.password
          });
        }
      } else {
        this.isValidationError = false;
      }
    }
  }
};
</script>

<style scoped>
.lp-container {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url("../../../assets/images/bg_logopattern.jpg");
}

form {
  -moz-box-shadow: 2px 4px 20px #000;
  -webkit-box-shadow: 2px 4px 20px #000;
  filter: progid:DXImageTransform.Microsoft.Shadow(Strength=10, Direction=155, Color='#000000');
  -ms-filter: "progid:DXImageTransform.Microsoft.Shadow(Strength=10, Direction=155, Color='#000000')";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  width: 370px;
  height: 270px;
  background: white;
  border-radius: 10px;
  background-image: -webkit-linear-gradient(15deg, #6f7c2b 0%, #d2eb30 100%);
  background-image: -moz-linear-gradient(15deg, #6f7c2b 0%, #d2eb30 100%);
  background-image: -o-linear-gradient(15deg, #6f7c2b 0%, #d2eb30 100%);
  background-image: -ms-linear-gradient(15deg, #6f7c2b 0%, #d2eb30 100%);
  background-image: linear-gradient(15deg, #6f7c2b 0%, #d2eb30 100%);
  background-color: #718107;
}

form:before {
  content: " ";
  background: url("../../../assets/images/logo.png") no-repeat;
  width: 216px;
  height: 200px;
  position: absolute;
  top: 35px;
  left: 77px;
  background-size: 100%;
}

.lp-div {
  text-align: center;
  position: relative;
  top: 130px;
}

.lp-button {
  position: absolute;
  margin: 0 auto;
  width: 70px;
  left: 0;
  right: 0;
  top: 140px;
  left: 154px;
  background-color: #ffb700;
  font-size: 14px;
  text-align: center;
  line-height: 23px;
  /* width: 78px; */
  -webkit-box-shadow: rgba(0, 0, 0, 0.45) 0px 1px 4px 0px;
  -moz-box-shadow: rgba(0, 0, 0, 0.611765) 0px 1px 4px 0px;
  box-shadow: rgba(0, 0, 0, 0.47) 0px 1px 4px 0px;
  -webkit-box-reflect: below 1px -webkit-linear-gradient(90deg, rgba(
          0,
          0,
          0,
          0.219608
        )
        0%, rgba(223, 227, 9, 0) 62%);
  text-shadow: rgba(255, 255, 255, 0.478431) 0px 1px 0px;
  background-image: -ms-linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.59) 100%
  );
  background-image: -moz-linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.59) 100%
  );
  background-image: -webkit-linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.59) 100%
  );
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  cursor: pointer;
  border-radius: 3px;
  outline: 0px;
  border: 0px;
}

.lp-button-ldap {
  position: absolute;
  margin: 0 auto;
  width: 70px;
  left: 0;
  right: 0;
  top: 140px;
  left: 0px;
  background-color: #ffb700;
  font-size: 14px;
  text-align: center;
  line-height: 23px;
  /* width: 78px; */
  -webkit-box-shadow: rgba(0, 0, 0, 0.45) 0px 1px 4px 0px;
  -moz-box-shadow: rgba(0, 0, 0, 0.611765) 0px 1px 4px 0px;
  box-shadow: rgba(0, 0, 0, 0.47) 0px 1px 4px 0px;
  -webkit-box-reflect: below 1px -webkit-linear-gradient(90deg, rgba(
          0,
          0,
          0,
          0.219608
        )
        0%, rgba(223, 227, 9, 0) 62%);
  text-shadow: rgba(255, 255, 255, 0.478431) 0px 1px 0px;
  background-image: -ms-linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.59) 100%
  );
  background-image: -moz-linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.59) 100%
  );
  background-image: -webkit-linear-gradient(
    91deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.59) 100%
  );
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  cursor: pointer;
  border-radius: 3px;
  outline: 0px;
  border: 0px;
}

.lp-input {
  border: 1px solid grey;
  outline: 0;
  font-size: 14px;
}

.lp-label {
  color: white;
  font-family: arial;
  font-size: 14px;
}

.lp-alert {
  position: relative;
  font-size: 14px;
  top: 170px;
  color: #ffb700;
  text-align: center;
  /* left: 140px; */
}
</style>